import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { zonePropertiesType, zoneType } from '../../types';
import useDetailHandler from '../../hooks/useDetailHandler';
import { onActionKey } from '../../utils';
import ZoneDetailTab from './ZoneDetailTab';
import FlagIcon from '../FlagIcon';
import './_styles_/ZoneRow.css';

export const getValueMapping = (t) => ({
    active: [
        {
            from: true,
            to: t('misc.yes'),
        },
        {
            from: false,
            to: t('misc.no'),
        },
    ],
});

ZoneRow.propTypes = {
    zone: zoneType.isRequired,
    zoneProps: zonePropertiesType.isRequired,
};

function ZoneRow(props) {
    const {
        zone,
        zoneProps,
    } = props;
    const { t } = useTranslation();
    const valueMapping = getValueMapping(t);
    const { isDetailVisible, toggleDetail, onDetailDelete } = useDetailHandler(zone.id);
    return (
        <>
            <div className="rich-list-row zone-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="zone-header--values--flag">
                    {zone.flagCode && <FlagIcon code={zone.flagCode} size="2x" className="flag-icon--shadowed flag-icon--32" squared />}
                </div>
                <div className="zone-header--values--name">{zone.name}</div>
                <div className="zone-header--values--code">{zone.code}</div>
                <div className="zone-header--values--clearing-house">{zone.clearingHouse.code}</div>
                <div className="zone-header--values--currency">{zone.currency.code}</div>
                <div className="zone-header--values--active">{zone.active ? valueMapping.active[0].to : valueMapping.active[1].to}</div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && (
                <ZoneDetailTab
                    zone={zone}
                    onDetailDelete={onDetailDelete}
                    zoneProps={zoneProps}
                />
            )}
        </>
    );
}

export default ZoneRow;
